import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@store/store'
import { prop } from 'ramda'

import {
  ACADEMIC_YEAR,
  ACADEMIC_YEAR_ALL,
  ACADEMIC_YEAR_CREATE,
  ACADEMIC_YEAR_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const academicYearGlobalSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const academicYearSelector = createSelector(academicYearGlobalSelector, data => data[ACADEMIC_YEAR])

export const academicYearAllSelector = createSelector(academicYearGlobalSelector, data => data[ACADEMIC_YEAR_ALL])

export const academicYearCreateSelector = createSelector(academicYearGlobalSelector, data => data[ACADEMIC_YEAR_CREATE])

export const academicYearListSelector = createSelector(academicYearGlobalSelector, data => data[ACADEMIC_YEAR_LIST])

export const academicYearAllOptionsSelector = createSelector(academicYearAllSelector, academicYearAll => {
  return {
    loading: academicYearAll.loading,
    error: academicYearAll.error,
    options: Array.isArray(academicYearAll.data)
      ? academicYearAll.data.map(item => ({ label: item.name || '', value: item.id }))
      : [],
  }
})

export const academicYearAllShortNameOptionsSelector = createSelector(academicYearAllSelector, academicYearAll => {
  return {
    loading: academicYearAll.loading,
    error: academicYearAll.error,
    options: Array.isArray(academicYearAll.data)
      ? academicYearAll.data.map(item => ({ label: item.short_name || '', value: item.id }))
      : [],
  }
})
